<script>
export default {
    name: 'IconStats',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-stats"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 52h48v4H8v-4zm9-20v16h-6V32h6zm12-16v32h-6V16h6zm12 8v24h-6V24h6zM53 8v40h-6V8h6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
